import React from "react";

import { Button, Section, Stack, Heading } from "@origin-digital/ods-core";

export interface IRegisterSectionProps {
  backgroundColour?: "transparent" | "grey50" | "white";
  content: IRegisterContent;
  link: string;
}

export interface IRegisterContent {
  heading: string;
  cta: { text: string; prodLocation: string; nonProdLocation: string };
}

export const RegisterSection: React.FC<IRegisterSectionProps> = ({
  backgroundColour = "transparent",
  content,
  link,
}) => (
  <Section backgroundColor={backgroundColour}>
    <Stack space="xlarge" alignX="center">
      <Heading variant="h3" align="center">
        {content.heading}
      </Heading>
      <Button href={link} variant="contained">
        {content.cta.text}
      </Button>
    </Stack>
  </Section>
);
